var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.13 6.82 10.504.267A.833.833 0 0 1 11.122 0c.238 0 .444.09.618.268a.88.88 0 0 1 .26.635.88.88 0 0 1-.26.635l-7 7.194A.825.825 0 0 1 4.13 9a.825.825 0 0 1-.61-.268L.253 5.375A.854.854 0 0 1 0 4.74a.907.907 0 0 1 .268-.636.833.833 0 0 1 .618-.267c.238 0 .444.089.618.267L4.13 6.82z",
    fill: "#006bd3",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.97a560607ebcad7eeed023fafd3a13d8.svg";
export { ForwardRef as ReactComponent };